export default "__VITE_ASSET__CUjyVMS7__"